export const ChartType = Object.freeze({
    BarChart: 'barChart',
    LineChart: 'lineChart'
});
